var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComputerFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 44,
    viewBox: "0 0 49 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 43.5999V41.1999L19.7 36.3999H5.3C3.98 36.3999 2.8504 35.9303 1.9112 34.9911C0.972 34.0519 0.5016 32.9215 0.5 31.5999V5.1999C0.5 3.8799 0.9704 2.7503 1.9112 1.8111C2.852 0.871902 3.9816 0.401502 5.3 0.399902H43.7C45.02 0.399902 46.1504 0.870302 47.0912 1.8111C48.032 2.7519 48.5016 3.8815 48.5 5.1999V31.5999C48.5 32.9199 48.0304 34.0503 47.0912 34.9911C46.152 35.9319 45.0216 36.4015 43.7 36.3999H29.3L34.1 41.1999V43.5999H14.9ZM5.3 24.3999H43.7V5.1999H5.3V24.3999Z",
    fill: "var(--secondary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerFilled);
export default __webpack_public_path__ + "static/media/computerFilled.95285c215da08e4c90d2f934256cf64d.svg";
export { ForwardRef as ReactComponent };